import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ToastWrapper = styled.div`
	display: flex;
	padding: var(--padding-2);
	width: 100%;
	z-index: var(--z-index-10);
	position: relative;

	@keyframes slideDown {
		0% {
			transform: translateY(-100%);
		}
		30% {
			transform: translateY(-120%);
		}
		80% {
			transform: translateY(10%);
		}
		100% {
			transform: translateY(0%);
		}
	}

	:not(:first-of-type) {
		animation-name: slideDown;
		animation-duration: 0.6s;
		animation-timing-function: ease-in-out;
	}

	&.showing {
		animation-name: showLeft;
		animation-duration: 0.6s;
		animation-timing-function: ease-in-out;

		body[dir='rtl'] & {
			animation-name: showRight;
		}

		@keyframes showLeft {
			0% {
				transform: translateX(150%);
			}
			10% {
				transform: translateX(150%);
			}
			80% {
				transform: translateX(-5%);
			}
			100% {
				transform: translateX(0%);
			}
		}

		@keyframes showRight {
			0% {
				transform: translateX(-150%);
			}
			10% {
				transform: translateX(-150%);
			}
			80% {
				transform: translateX(5%);
			}
			100% {
				transform: translateX(0%);
			}
		}
	}

	&.exiting {
		animation-name: exitRight;
		animation-duration: 0.6s;
		animation-timing-function: ease-in-out;

		body[dir='rtl'] & {
			animation-name: exitLeft;
		}

		@keyframes exitRight {
			from {
				transform: translateX(0%);
			}
			to {
				transform: translateX(200%);
			}
		}

		@keyframes exitLeft {
			from {
				transform: translateX(0%);
			}
			to {
				transform: translateX(-200%);
			}
		}
	}
`;

export const ToastManagerContainer = styled.div`
	background: transparent;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 8rem;
	right: 2rem;
	z-index: var(--z-index-10);
	width: 500px;

	body[dir='rtl'] & {
		right: unset;
		left: 2rem;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
		top: 2rem;
		left: 0 !important;
		right: 0 !important;
	}
`;
